import * as React from "react";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";
import { Input } from "@/components/ui";

function IconInput({
  icon,
  className,
  inputClassName = "",
  type,
  ...props
}: React.ComponentProps<"input"> & {
  icon: LucideIcon;
  inputClassName?: string;
}) {
  const Comp = icon;
  return (
    <div className={cn("relative", className)}>
      <div className="absolute top-0 bottom-0 left-3 flex items-center">
        <Comp className="size-4" />
      </div>
      <Input className={cn("pl-8", inputClassName)} type={type} {...props} />
    </div>
  );
}

export { IconInput };
